import React, { useEffect, useState, useRef } from 'react';
// eslint-disable-next-line import/no-named-as-default
import useSound from 'use-sound';
import beep1 from '../../assets/sounds/beep1.mp3';
import beep2 from '../../assets/sounds/beep2.mp3';
import beep3 from '../../assets/sounds/beep3.mp3';
import moment from 'moment';
import 'moment/locale/es';

const RepChrono = (props) => {
  const [diff, setDiff] = useState(null);
  const [initial, setInitial] = useState(null);
  const [startChrono, setStartChrono] = useState(false);

  const changeDone = useRef(false);

  useEffect(() => {
    start();
  }, []);

  const start = () => {
    if (!startChrono) {
      setInitial(+new Date());
      setStartChrono(true);
    }
    if (startChrono) setStartChrono(false);
  };

  useEffect(() => {
    changeDone.current = false;
    if (props.lastSet) {
      playBeep1();
    } else {
      playBeep3();
    }
  }, [props.set]);

  const [playBeep1] = useSound(beep1);
  const [playBeep2] = useSound(beep2);
  const [playBeep3] = useSound(beep3);

  const tick = () => {
    const update = Date.now() - initial;
    const totalMs = props.set.time * 1000;
    const total = parseInt(props.set.time);

    const formatProgress = (ms) => {
      const seconds = Math.floor(ms / 1000);
      const milliseconds = ms % 1000;
      return seconds.toString() + milliseconds.toString().padStart(3, '0');
    };

    props.handleProgress(formatProgress(update), total * 1000);
    if (!changeDone.current && update >= totalMs && !props.lastSet) {
      changeDone.current = true;
      props.handleChangeSet();
      setInitial(Date.now());
    }
    setDiff(update);
  };

  useEffect(() => {
    let timer;
    if (startChrono) {
      timer = setInterval(() => {
        tick();
      }, 100); // o 1000ms si sólo quieres precisión de segundos
    }
    return () => clearInterval(timer);
  }, [startChrono, initial]);

  const timeFormat = (date) => {
    if (!date) return '00:00';

    const mm = Math.floor(diff / 60000)
      .toString()
      .padStart(2, '0');
    const ss = Math.floor((diff % 60000) / 1000)
      .toString()
      .padStart(2, '0');
    const ms =
      Math.floor((diff % 1000) / 100)
        .toString()
        .padStart(1, '0') + '0';
    return `${ss}:${ms}`;
  };

  return <div className='App'>{timeFormat(diff)}</div>;
};

export default RepChrono;
